module.exports = __webpack_public_path__ + "static/media/20240130082717_IMG_5070 (1).362e74b5.jpg";